import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ModalProps } from './automation-free-limit-modal';

const AutomationLimitsEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		ModalProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-automation-free-limit-modal" */ './automation-free-limit-modal'
			),
		{
			moduleId: 'edition-awareness-automation-free-limit-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});

export default AutomationLimitsEntryPoint;
